import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Block as BlockIcon, Home as HomeIcon } from '@mui/icons-material';
import { colors, fonts, spacing, borderRadius, shadows } from '../constants';
import { getDefaultRedirectPath } from '../utils/redirectUtils';
import { useAuth } from '../context/AuthContext';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoHome = () => {
    const redirectPath = getDefaultRedirectPath(user);
    navigate(redirectPath);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.background,
        p: spacing.md,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 600,
          width: '100%',
          p: spacing.xl,
          borderRadius: borderRadius.lg,
          boxShadow: shadows.lg,
          border: `1px solid ${colors.borderDefault}`,
          background: colors.backgroundWhite,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: spacing.md,
          }}
        >
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: '50%',
              backgroundColor: `${colors.error}15`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: spacing.sm,
            }}
          >
            <BlockIcon
              sx={{
                fontSize: 64,
                color: colors.error,
              }}
            />
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontWeight: fonts.weightBold,
              color: colors.textPrimaryDark,
              mb: spacing.xs,
            }}
          >
            Access Denied
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: colors.textSecondary,
              fontSize: fonts.fontSizeMd,
              lineHeight: fonts.lineHeightRelaxed,
              mb: spacing.md,
              maxWidth: 480,
            }}
          >
            You don't have permission to access this page. This page is restricted to authorized users only.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: colors.textTertiary,
              fontSize: fonts.fontSizeSm,
              mb: spacing.lg,
            }}
          >
            If you believe this is an error, please contact your administrator.
          </Typography>

          <Button
            variant="contained"
            onClick={handleGoHome}
            startIcon={<HomeIcon />}
            sx={{
              textTransform: 'none',
              fontSize: fonts.fontSizeMd,
              fontWeight: fonts.weightSemiBold,
              padding: `${spacing.sm} ${spacing.lg}`,
              borderRadius: borderRadius.button,
              background: colors.buttonPrimary,
              color: colors.buttonPrimaryText,
              boxShadow: shadows.button,
              '&:hover': {
                background: colors.buttonPrimaryHover,
                boxShadow: shadows.buttonHover,
              },
            }}
          >
            Go to Dashboard
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default Unauthorized;

